import React, { useState } from 'react'
import Style from '../summaryDetails.module.css'
export const ID_FIELDS = [
    { key: 'messageId', label: 'Message ID', numeric: true },
    { key: 'sourceId', label: 'Source ID' },
    { key: 'targetId', label: 'Target ID' },
    { key: 'reference', label: 'Reference' }
]

export const IdFilterPanel = ({ filters, onApply, onClose }) => {
    const [draft, setDraft] = useState(() =>
        ID_FIELDS.reduce((acc, field) => ({ ...acc, [field.key]: filters[field.key] }), {})
    )
    const apply = (event) => {
        event.preventDefault()
        onApply({ ...filters, ...draft })
    }
    const clear = () => {
        const empty = ID_FIELDS.reduce((acc, field) => ({ ...acc, [field.key]: '' }), {})
        setDraft(empty)
        onApply({ ...filters, ...empty })
    }
    return (
        <form className={Style.filterPanel} onSubmit={apply}>
            <div className={Style.filterGrid}>
                {ID_FIELDS.map((field) => (
                    <label key={field.key} className={Style.field}>
                        <span className={Style.fieldLabel}>{field.label}</span>
                        <input
                            className={Style.fieldInput}
                            value={draft[field.key]}
                            inputMode={field.numeric ? 'numeric' : undefined}
                            placeholder={`Enter ${field.label.toLowerCase()}`}
                            onChange={(event) => {
                                const value = field.numeric ? event.target.value.replace(/\D/g, '') : event.target.value
                                setDraft({ ...draft, [field.key]: value })
                            }}
                        />
                    </label>
                ))}
            </div>
            <div className={Style.filterActions}>
                <button type="button" className={Style.ghostButton} onClick={onClose}>Close</button>
                <button type="button" className={Style.ghostButton} onClick={clear}>Clear</button>
                <button type="submit" className={Style.primaryButton}>Apply filters</button>
            </div>
        </form>
    )
}
export const ActiveFilterChips = ({ filters, onChange }) => {
    const active = ID_FIELDS.filter((field) => filters[field.key].trim() !== '')
    if (active.length === 0) return null
    return (
        <div className={Style.chips}>
            {active.map((field) => (
                <span key={field.key} className={Style.chip}>
                    {field.label}: <strong>{filters[field.key]}</strong>
                    <button
                        type="button"
                        className={Style.chipRemove}
                        aria-label={`Remove ${field.label} filter`}
                        onClick={() => onChange({ ...filters, [field.key]: '' })}
                    >
                        &times;
                    </button>
                </span>
            ))}
            {active.length > 1 ? (
                <button
                    type="button"
                    className={Style.clearAll}
                    onClick={() => onChange({ ...filters, messageId: '', sourceId: '', targetId: '', reference: '' })}
                >
                    Clear all
                </button>
            ) : null}
        </div>
    )
}
